<template>
    <div class="header flex-between flex-cross-center">
        <div class="header-l">
            <div class="header-name flex-cross-center">
                <div class="header-log"></div>
                <div class="text">智能健康评估系统</div>
            </div>
        </div>
        <div class="header-r" v-if="$root.showName">
            <el-dropdown  trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                {{userName||""}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="editPassword">修改密码</el-dropdown-item>
                    <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <EditPassword ref="EditPassword" />
    </div>
</template>
<script>
    import EditPassword from "./EditPassword";
    import { mapGetters } from "vuex";
    import db from "@/assets/js/localstorage";
    export default{
        components: { EditPassword },
        data(){
            return {

            }
        },
        computed:{
            ...mapGetters(["userName"]),
        },
        created(){
        },
        mounted(){
        },
        methods: {
            // 切换用户菜单调用对应方法
            handleCommand(command) {
                this[command]();
            },
            // 登出
            logout() {
                this.axios
                    .post(this.getApiUrl("logout"))
                    .then((res) => {
                        if (res.code === 1) {
                            this.$message.success("退出成功");
                            db.clear();
                            this.$router.push({
                                path: "/login",
                            });
                        } else {
                            this.$message.warning(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.$message.error("登出失败");
                        console.log(err);
                    });
            },
            // 修改密码
            editPassword() {
                this.$refs.EditPassword.visible = true;
                this.$nextTick(() => {
                    this.$refs.EditPassword.clearValidate();
                    this.$refs.EditPassword.clearVals();
                });
            },
            showPwdRule() {
                this.$alert(
                    "密码必须8位以上并且包含大小写字母数字和特殊符号!",
                    "密码规则",
                    {
                        confirmButtonText: "确定",
                        callback: (action) => {
                            console.log(action)
                        },
                    }
                );
            },
            sendChange() {
                let self = this;
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        self.submitPwd();
                    } else {
                        console.log("校验有问题");
                        return false;
                    }
                });
            },
            // 确定修改密码
            submitPwd() {
                if (this.form.newPassword !== this.form.confirmPassword) {
                    this.$message.error("新密码与确认密码不一致");
                    this.form.confirmPassword = "";
                    return false;
                }

                let p = {
                    oldPassword: this.form.oldPassword,
                    newPassword: this.form.newPassword,
                };
                this.axios
                    .post(this.getApiUrl("adminResetPwd"), p)
                    .then((response) => {
                        if (response.status === 200) {
                            this.$message.success("修改成功");
                            this.editPwdVisible = false;
                        } else {
                            this.$message.error(response.msg);
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: "error",
                            message: "修改密码失败",
                        });
                    });
            },
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    @import "@/assets/css/color.scss";
    .input-w {
        width: 363px;
    }
    .header {
        height: $head_h;
        padding: 0 25px 0 0;
        background: $theme;
        flex-shrink: 0;
        color: #ffffff;
        box-sizing: border-box;
    }
    .el-dropdown-link{
        cursor: pointer;
        color: #ffffff;
    }
    .header-name{
        height: 38px;
        box-sizing: border-box;
    }
    .header-log{
        height: 38px;
        width: 255px;
        background: url('../../../../public/img/logo_light.png') no-repeat center center;
        background-size: auto 34px;
    }
    .text{
        opacity: 1;
        visibility: visible;
        word-break: keep-all;
        padding-left: 4px;
        font-size: 16px;
        transition: all .5s;
    }
    .header-l{
        flex: 1;
    }
    .header-r{
        width: fit-content;
        word-break: keep-all;
        flex-shrink: 0;
    }
    @media only screen and (max-width: 520px) {
        .text{
            opacity: 0;
            visibility: hidden;
            display: none;
        }
    }
</style>